import React, { useState, useEffect, useRef } from 'react';
import { useAddNewNamirnicuMutation, useUpdateNamirnicuMutation, useGetAllNamirniceQuery, useDeleteNamirnicuMutation } from '../features/Namirnice/namirniceApiSlice';
import { useGetIshraneNamesQuery } from '../features/ishrana/ishranaApiSlice';
import { useGetAllSpecCiljeviQuery } from '../features/ciljevi/ciljeviApiSlice';

const NaminicaFormAliSamoCiljevi = () => {
  const [naziv, setNaziv] = useState('');
  const [laktoza, setLaktoza] = useState(false);
  const [gluten, setGluten] = useState(false);
  const [alergen, setAlergen] = useState(false);
  const [grupa, setGrupa] = useState('');
  const [podtip, setPodtip] = useState('');
  const [odabraneIshrane, setOdabraneIshrane] = useState([]);
  const [odabraniCiljevi, setOdabraniCiljevi] = useState([]);
  const [namirnice, setNamirnice] = useState([]);
  const [availableIshrane, setAvailableIshrane] = useState([]);
  
  const [availableCiljevi, setAvailableCiljevi] = useState([]);

  const { isSuccess: isSuccessGetNamir, data: getNamirData } = useGetAllNamirniceQuery();
  const { isSuccess: isSuccessGetIshName, data: getIshNameData } = useGetIshraneNamesQuery();
  const { isSuccess: isSuccessGetCiljevi, data: getCiljeviData } = useGetAllSpecCiljeviQuery();

  useEffect(() => {
    if (isSuccessGetNamir) {
      setNamirnice(Object.values(getNamirData.entities || {}));
    }

    if (isSuccessGetIshName) {
      setAvailableIshrane(Object.values(getIshNameData.entities || []));
    }

    if (isSuccessGetCiljevi) {
      setAvailableCiljevi(Object.values(getCiljeviData.entities || []));
    }
  }, [isSuccessGetNamir, isSuccessGetIshName, isSuccessGetCiljevi, getNamirData, getIshNameData, getCiljeviData]);

  const handleIshraneChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setOdabraneIshrane([...odabraneIshrane, value]);
    } else {
      setOdabraneIshrane(odabraneIshrane.filter((ishrana) => ishrana !== value));
    }
  };

  const handleCiljeviChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setOdabraniCiljevi([...odabraniCiljevi, value]);
    } else {
      setOdabraniCiljevi(odabraniCiljevi.filter((cilj) => cilj !== value));
    }
  };

  return (
    <div>
      {/* Tabela sa namirnicama */}
      <div className="overflow-auto max-h-96 mt-6">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-100 sticky top-0 z-10">
            <tr>
              <th className="px-4 py-2 border">Grupa</th>
              <th className="px-4 py-2 border">Podtip</th>
              <th className="px-4 py-2 border">Naziv</th>
              <th className="px-4 py-2 border">Laktoza</th>
              <th className="px-4 py-2 border">Gluten</th>
              <th className="px-4 py-2 border">Alergen</th>
              {/* Prikaz kolona za ishrane */}
              {availableIshrane.map((ishrana) => (
                <th key={ishrana._id} className="px-4 py-2 border">
                  {ishrana.naziv}
                </th>
              ))}
              {/* Prikaz kolona za ciljeve */}
              {availableCiljevi.map((cilj) => (
                <th key={cilj._id} className="px-4 py-2 border">
                  {cilj.naziv}
                </th>
              ))}
              <th className="px-4 py-2 border">Akcije</th>
            </tr>
          </thead>
          <tbody>
            {namirnice.map((namirnica) => (
              <tr key={namirnica._id}>
                <td className="px-4 py-2 border">{namirnica.grupa}</td>
                <td className="px-4 py-2 border">{namirnica.podtip}</td>
                <td className="px-4 py-2 border">{namirnica.naziv}</td>
                <td className="px-4 py-2 border">{namirnica.laktoza ? 'Da' : 'Ne'}</td>
                <td className="px-4 py-2 border">{namirnica.gluten ? 'Da' : 'Ne'}</td>
                <td className="px-4 py-2 border">{namirnica.alergen ? 'Da' : 'Ne'}</td>

                {/* Prikaz checkboxova za ishrane */}
                {availableIshrane.map((ishrana) => (
                  <td key={ishrana._id} className="px-4 py-2 border text-center">
                    <input
                      type="checkbox"
                      checked={namirnica.ishrane.includes(ishrana.naziv)}
                      readOnly
                    />
                  </td>
                ))}
                
                {/* Prikaz checkboxova za ciljeve */}
                {availableCiljevi.map((cilj) => (
                  <td key={cilj._id} className="px-4 py-2 border text-center">
                    <input
                      type="checkbox"
                      checked={namirnica.ciljevi.includes(cilj.naziv)}
                      readOnly
                    />
                  </td>
                ))}

                <td className="px-4 py-2 border text-center">
                  <button className="text-red-500 font-bold">Izbriši</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NaminicaFormAliSamoCiljevi;
